import {
  Modal as ChakraModal,
  type ModalProps as ChakraModalProps,
} from '@chakra-ui/react';
import type { OverrideProperties } from 'type-fest';

import type { ModalVariantPublic } from './types';

export type ModalProps = OverrideProperties<
  ChakraModalProps,
  {
    variant?: ModalVariantPublic;
  }
>;

export const Modal = ({
  children,
  preserveScrollBarGap = true,
  ...restProps
}: ModalProps) => (
  <ChakraModal preserveScrollBarGap={preserveScrollBarGap} {...restProps}>
    {children}
  </ChakraModal>
);
